import axios from "axios";

export default {
  name: "userPasswordSection",
  // created: {
  // },
  data() {
    return {
      oldpassword: "",
      newPassword: "",
      confirmPassword: "",
    };
  },
  methods: {
    updateProfile() {
      if (this.newPassword == this.confirmPassword) {
        var user = {
          userId: window.localStorage.getItem("Giftstore-U"),
          oldpassword: this.firstName,
          newPassword: this.lastName,
        };
        axios
          .post(
            "https://giftstore-blog.herokuapp.com/api/user/updateProfile",
            user
          )
          .then((response) => {
            this.$store.commit("setUserInfo", response.data.user);
            this.$toast.open({
              message: "Compte bien modifier",
              type: "success",
              position: "top-right",
              // all of other options may go here
            });
          })
          .catch((error) => {
            console.error("There was an error!", error);
            this.$toast.open({
              message: "Erreur lors de la modification",
              type: "error",
              position: "top-right",
              // all of other options may go here
            });
          });
      }
    },
  },
};
